import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { showAlertModal, changePassword, closeChangePassword } from '../../actions'

const ChangePassword = props => {
  const {user, loginError, showAlertModal, changePassword, closeChangePassword} = props
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // cleanup state update on unmount
    return () => {
      setLoading(false)
    }
  }, [])

  const toggleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword)
  }

  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword)
  }

  const onSave = async () => {
    setLoading(true)
    if (oldPassword.trim() === '' || newPassword.trim() === '') {
      return showAlertModal(['WARNING', 'Please fill in all details'])
    }

    await changePassword(user.bID, oldPassword, newPassword)
    setLoading(false) 
  }

  return (
     <div style={styles.containerStyle}>
      <h1 style={styles.headingStyle}>Change Password</h1>
      <hr style={{ ...styles.dividerStyle, marginBottom: 10 }} />
      <p style={{...styles.errorTextStyle, backgroundColor: 'rgba(255,255,255,0.9)' }}>{loginError}</p>

      <div style={{...styles.inputContainerStyle, marginTop: 10 }}>
        <p style={styles.inputLabelStyle} >old password</p>
        <input type={showOldPassword ? "text" : "password"} value={oldPassword} onChange={e => setOldPassword(e.target.value)} placeholder="enter temporary password" style={styles.inputStyle} autoFocus={true} />
        {showOldPassword
          ? <FaEye title="Hide Password" style={styles.icon} onClick={toggleShowOldPassword} />
          : <FaEyeSlash title="Show Password" style={styles.icon} onClick={toggleShowOldPassword} />
        }
      </div>

      <div style={{ ...styles.inputContainerStyle, marginBottom: 30 }}>
        <p style={styles.inputLabelStyle} >new password</p>
        <input type={showNewPassword ? "text" : "password"} value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="enter new password" style={styles.inputStyle}
          onKeyDown={e => {e.keyCode === 13 && onSave()}} />
        {showNewPassword
          ? <FaEye title="Hide Password" style={styles.icon} onClick={toggleShowNewPassword} />
          : <FaEyeSlash title="Show Password" style={styles.icon} onClick={toggleShowNewPassword} />
        }
      </div>

      <hr style={{ ...styles.dividerStyle, marginBottom: 20 }} />

      <div>
        <button onClick={loading ? null : onSave} style={styles.button} disabled={loading}>Save</button>
        <button onClick={closeChangePassword} style={styles.button}>Cancel</button>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { user, loginError } = state.auth
  return { user, loginError }
}

export default connect(mapStateToProps, { showAlertModal, changePassword, closeChangePassword })(ChangePassword);

const styles = {
  containerStyle: {
    padding: 10,
    textAlign: 'center'
  },
  headingStyle: {
    color: 'white',
    textAlign: 'center',
    margin: 0,
    padding: 0,
    marginBottom: 10,
    fontSize: '3vmin'
  },
  dividerStyle: {
    boxShadow: '0 1px 1px #000033',
  },
  inputContainerStyle: {
    position: 'relative',
    width: '80%',
    maxWidth: 280,
    margin: 'auto',
    marginBottom: 10,
    marginTop: 5
  },
  errorTextStyle: {
    color: '#ff4d4d',
    padding: '3px 0',
    fontWeight: 'bold',
    borderRadius: 5,
    width: '90%',
    margin: 'auto',
    fontSize: '1.6vmin'
  },
  inputLabelStyle: {
    textAlign: 'left',
    margin: 0,
    marginBottom: 8,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1.6vmin'
  },
  inputStyle: {
    width: '100%',
    padding: 3,
    paddingRight: '2vmin',
    borderRadius: 5,
    fontSize: '1.6vmin',
  },
  icon: { cursor: 'pointer', fontSize: '1.8vmin' , position: 'absolute', bottom: '0.5vmin', right: '0.5vmin', width: '1vw', color: 'black', },
  button: {
    padding: 3,
    width: '80%',
    maxWidth: 200,
    margin: '0px 5px 10px',
    fontSize: '1.6vmin',
    borderRadius: 5,
    cursor: 'pointer'
  }
}